import { BaseAPI } from "@/api/baseAPI";
import apiClient from "@/api/apiClient";
import { extractApiData } from "@/utils/apiResponseHandler";
import type { User } from "@/types";

class UserAPI extends BaseAPI<User> {
  constructor() {
    super("user");
  }

  /**
   * Fetch managers.
   * @returns Promise resolving to an array of manager objects.
   */
  async fetchManagers(): Promise<User[]> {
    return await apiClient
      .get(`${this.model}/managers`)
      .then(extractApiData);
  }

  /**
   * Fetch the current user.
   * @returns Promise resolving to the current user object.
   */
  async fetchCurrentUser(): Promise<User> {
    return await apiClient
      .get(`${this.model}/current`)
      .then(extractApiData);
  }

  /**
   * Change the password of the current user.
   * @param body Request body containing password change information.
   * @returns Promise resolving to a success message.
   */
  async changePassword(body: { oldPassword: string; newPassword: string }): Promise<void> {
    return await apiClient
      .post(`${this.model}/change-password`, body)
      .then(extractApiData);
  }

  async fetchProfilePictureById(id: number): Promise<Pick<User, 'profile_picture'>> {
    return await apiClient
      .get(`${this.model}/${id}/profile-picture`)
      .then(extractApiData);
  }
}

export default new UserAPI();

